import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import * as rtfToHTML from "@iarna/rtf-to-html";

@Pipe({
    name: "stringToContent",
    standalone: false
})
export class StringToContentPipe implements PipeTransform {
  readonly rtfRegex: RegExp = /^{\\rtf1/;

  constructor(private translate: TranslateService) {}

  private rtfToHTMLAsync(str: string): Promise<string> {
    return new Promise((resolve, reject) => {
      rtfToHTML.fromString(str, (err, html) => {
        if (err) {
          reject(err);
        } else {
          resolve(html);
        }
      });
    });
  }

  async transform(str: string): Promise<string> {
    if (!str) {
      return "<b>Error</b>";
    }

    if (str.match(this.rtfRegex)) {
      try {
        return await this.rtfToHTMLAsync(str);
      } catch (error) {
        console.error("Error during RTF conversion:", error);
        return "<b>Error during RTF conversion</b>";
      }
    } else {
      return str;
    }
  }
}
